import React, { useState } from 'react';
import './Staff.css';

const staff = [
  {
    name: 'Jeslin Nazeema.J',
    experience: '3+ years',
    // qualification: 'B.Sc & B.Ed',
    subject: 'Maths & physics',
    color: '#1a56db',
    initials: 'JE',
    gradient: 'linear-gradient(135deg,#1a56db,#0d1b4b)',
  },
  {
    name: 'Kayathri Manokaran',
    experience: '6+ years',
    // qualification: 'B.Sc & B.Ed',
    subject: 'Tamil',
    color: '#1e8a45',
    initials: 'GA',
    gradient: 'linear-gradient(135deg,#1e8a45,#0a4a22)',
  },
  {
    name: 'S.Anusha',
    experience: '4+ years',
    // qualification: 'B.Sc & B.Ed',
    subject: 'Social Science',
    color: '#7c3aed',
    initials: 'AN',
    gradient: 'linear-gradient(135deg,#7c3aed,#4c1d95)',
  },
  {
    name: 'Seshanth',
    experience: '2+ years',
    // qualification: 'B.Sc & B.Ed',
    subject: 'chemistry & english',
    color: '#0891b2',
    initials: 'SE',
    gradient: 'linear-gradient(135deg,#0891b2,#0e4f63)',
  },
];

export default function Staff() {
  const [active, setActive] = useState(0);

  const prev = () => setActive((p) => (p === 0 ? staff.length - 1 : p - 1));
  const next = () => setActive((p) => (p === staff.length - 1 ? 0 : p + 1));

  /* Show 3 cards on desktop, 1 on mobile */
  const visible = [
    staff[(active) % staff.length],
    staff[(active + 1) % staff.length],
    staff[(active + 2) % staff.length],
  ];

  return (
    <section className="staff-section" id="staff">
      <div className="staff-wrapper">

        <div className="staff-header">
          <span className="section-badge">Our Team</span>
          <h2 className="section-title">Meet Our Expert Staff</h2>
          <p className="section-sub">
            A dedicated team of qualified educators committed to nurturing every student's potential.
          </p>
        </div>

        <div className="staff-carousel-wrap">
          {/* Prev Button */}
          <button className="carousel-btn prev-btn" onClick={prev} aria-label="Previous">
            &#8249;
          </button>

          {/* Cards */}
          <div className="staff-cards">
            {visible.map((s, i) => (
              <div
                className={`staff-card ${i === 1 ? 'staff-card--center' : ''}`}
                key={s.name + i}
              >
                {/* Avatar area */}
                <div className="staff-avatar-area">
                  <div
                    className="staff-avatar"
                    style={{ background: s.gradient }}
                  >
                    {s.initials}
                  </div>
                </div>

                {/* Info panel */}
                <div className="staff-info">
                  <span className="staff-exp-badge">{s.experience} exp</span>
                  <h3 className="staff-name">{s.name}</h3>
                  <p className="staff-subject">{s.subject} Teacher</p>
                  <p className="staff-qual">{s.qualification}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Next Button */}
          <button className="carousel-btn next-btn" onClick={next} aria-label="Next">
            &#8250;
          </button>
        </div>

        {/* Dots */}
        <div className="staff-dots">
          {staff.map((_, i) => (
            <button
              key={i}
              className={`staff-dot ${i === active ? 'active' : ''}`}
              onClick={() => setActive(i)}
              aria-label={`Go to staff ${i + 1}`}
            />
          ))}
        </div>

      </div>
    </section>
  );
}
